import FaqContainer from '../partialComponents/FaqContainer'
import BasicTemplate from '../templates/BasicTemplate'
import { faqs } from '../utils/faqs'
import StateBenefits from '../partialComponents/StateBenefits'
import { benefits } from '../utils/benefits'
import StateCbseHero from '../partialComponents/StateCbseHero'
import StateCbseGrains from '../partialComponents/StateCbseGrains'
import HelmetGenerator from '../partialComponents/HelmetGenerator'
import { helmets } from '../utils/helmets'
import { useEffect } from 'react'
import GetStarted from '../partialComponents/GetStarted'
import WhoCanBenefitHeptagon from '../partialComponents/WhoCanBenefitHeptagon'
import stateWave from '../../Assets/layout_images/stateWave.png'
import { whoCanBenefit } from '../utils/whoCanBenefit'
import { useLocation } from 'react-router'
import FeesComparision from './feescomparision'
import StudentTestimonials from '../partialComponents/StudentTestimonials'
import Steps from '../partialComponents/steps'

export default function StateSyllabus() {
    const location = useLocation()
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [location])
    return (
        <>
            <HelmetGenerator details={helmets.state} />
            <BasicTemplate>
                <div className="state_page_section">
                    <StateCbseHero cbse={false} />
                    {/* <StateCbseGrains /> */}
                    <StateBenefits benefits={benefits.state} />
                    <WhoCanBenefitHeptagon
                        page={'state'}
                        waveTop={stateWave}
                        whoCanBenefits={whoCanBenefit.state}
                    />

                    <Steps type={'state'} color={'#4394F7'} />
                    <FeesComparision/>
                    <div className="home_section">  
                    <StudentTestimonials type={"ICSE"} />
                    </div>
                    <FaqContainer faqList={faqs.state} />
                </div>
            </BasicTemplate>
        </>
    )
}
